export default [
  {
    title: 'مدیریت مجله و لندینگ',
    icon: 'bx bx-chalkboard',
    children: [
      {
        title: 'مقاله ها',
        route: { name: 'blog' },
        resource: 'BlogManager',
        action: 'show',
      },
      {
        title: 'دسته بندی ها',
        route: { name: 'blogcategory' },
        resource: 'BlogCategoryManager',
        action: 'show',
      },
      {
        title: 'نظرها',
        route: { name: 'blogcomment' },
        resource: 'BlogCommentManager',
        action: 'show',
      },
      {
        title: 'ری دایرکت',
        route: { name: 'blogRedirect' },
        resource: 'BlogManager',
        action: 'show',
      },
      {
        title: 'محصولات',
        route: { name: 'products' },
        resource: 'BlogManager',
        action: 'show',
      },
      {
        title: 'اسلایدر',
        route: { name: 'sliders' },
        resource: 'BlogManager',
        action: 'show',
      },
      {
        title: 'لندینگ',
        route: { name: 'landings' },
        resource: 'BlogManager',
        action: 'show',
      },
    ],
  },
]
